var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('span',{staticClass:"not-fond"},[_vm._v("此页面不存在")]),_c('div',{staticClass:"back-btn",on:{"click":_vm.backIndex}},[_vm._v("返回首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }